//------------------------------------------------------
//	セールタイマーのカウントダウン
//
//	商品ページでも使うが、お買い物かごの中からも使用しているので
//	このルーチンだけ分離してあります。
//
//	このルーチンはお買い物かごのcart_start.phpから参照していますので、一沿いどうする際は注意
//------------------------------------------------------
var saleanim = function()
{
	$(".sale_timer").each(function(){

		end_time = $(this).data("end-time");

		now_time = parseInt((new Date)/1000);
		var diff_time = end_time - now_time;

		if(diff_time < 0){
			$(this).html("1秒");
			 return;
		}

		var sec;
		var hour;
		var min;
		var day;

		sec = hour = min = day = 0;
		sec = parseInt(diff_time % 60);
		min = parseInt(diff_time / 60);
		if(min > 0) hour = parseInt(min / 60);
		if(hour > 0) min = min - (hour * 60);
		if(hour > 0) day = parseInt(hour / 24);
		if(day > 0) hour = hour - (day * 24);

		var str ="";
		if(day > 0) str = day+"日";
		if((day > 0) || (hour > 0)) str += hour+"時間";
		if((day > 0) || (hour > 0) || (min > 0)) str += min+"分";
		str += sec+"秒";

		$(this).html(str);

	});
}

$(document).ready(function(){
	var SaleTimer = setInterval(saleanim, 1000);
});
